import React from 'react';

import SLOT_STATUSES from '../../../constants/slotStatuses';

import './SplitShiftDetailsOverlay.scss';

const SegmentTime = ({ segment }) =>
	segment.status_code === SLOT_STATUSES.FACILITY_CANCELLED ? (
		<span className="split-shift-details-overlay__table__cancelled">CANCELLED</span>
	) : (
		segment.time_range
	);

/**
 * Segment / time / unit table shown by the split shift details overlay (desktop) and modal (mobile).
 * @param {Array<object>} segments - slot segments from useGetSlotSegmentsQuery
 * @param {boolean} isFetching - whether the segments are loading; renders skeleton rows while true
 * @param {number} segmentsCount - expected number of segments, used to size the skeleton
 * @param {boolean} hasNoSegments - the split was reverted after the row was rendered
 * @returns {JSX.Element}
 */
const SplitShiftSegmentsTable = ({ segments, isFetching, segmentsCount, hasNoSegments }) => {
	const placeholderRowCount = segmentsCount > 0 ? segmentsCount : 1;
	const placeholderRowKeys = Array.from({ length: placeholderRowCount }, (_, index) => `skeleton-${index}`);

	if (hasNoSegments) {
		return (
			<div className="split-shift-details-overlay__empty">
				This shift has been updated, please refresh the schedule to see the changes
			</div>
		);
	}

	return (
		<table className="split-shift-details-overlay__table" aria-busy={isFetching}>
			<thead>
				<tr>
					<th>Segment</th>
					<th>Time</th>
					<th>Unit</th>
				</tr>
			</thead>
			<tbody>
				{isFetching
					? placeholderRowKeys.map((rowKey) => (
							<tr key={rowKey} aria-hidden>
								<td aria-hidden className="split-shift-details-overlay__table__segment-number">
									<span className="split-shift-details-overlay__loading" />
								</td>
								<td aria-hidden>
									<span className="split-shift-details-overlay__loading" />
								</td>
								<td aria-hidden>
									<span className="split-shift-details-overlay__loading" />
								</td>
							</tr>
					  ))
					: segments.map((segment) => (
							<tr key={segment.segment_number}>
								<td className="split-shift-details-overlay__table__segment-number">{segment.segment_number}</td>
								<td>
									<SegmentTime segment={segment} />
								</td>
								<td>{segment.unit_name || '-'}</td>
							</tr>
					  ))}
			</tbody>
		</table>
	);
};

export default SplitShiftSegmentsTable;
